module.exports = __webpack_public_path__ + "img/icon-16-ic-arrow-w.8d7b89ef.svg";